import React from 'react'
import { Card } from 'antd'
import { MetricSelector } from '../../forms/MetricSelector'
import { CampaignSelector } from '../../forms/CampaignSelector'
import { TimeControls } from '../../forms/TimeControls'
import { BarMetricSelector } from '../../forms/BarMetricSelector'
import { CampaignTotalsSummary } from './CampaignTotalsSummary'
import { MetricKey, TimeGranularity, SummaryData } from './types'
import type { Dayjs } from 'dayjs'

interface PerformanceChartControlsProps {
  selectedCampaignIds: string[]
  selectedCampaignNames: Record<string, string>
  selectedMetrics: MetricKey[]
  onMetricChange: (checkedValues: MetricKey[]) => void
  visibleMetrics: any[]
  timeGranularity: TimeGranularity
  onTimeGranularityChange: (value: TimeGranularity) => void
  dateRange: [Dayjs, Dayjs]
  onDateRangeChange: (values: [Dayjs | null, Dayjs | null] | null) => void
  barMetric: MetricKey
  onBarMetricChange: (value: MetricKey) => void
  summaryData: SummaryData | null
  summaryLoading: boolean
  className?: string
}

export const PerformanceChartControls: React.FC<PerformanceChartControlsProps> = ({
  selectedCampaignIds,
  selectedCampaignNames,
  selectedMetrics,
  onMetricChange,
  visibleMetrics,
  timeGranularity,
  onTimeGranularityChange,
  dateRange,
  onDateRangeChange,
  barMetric,
  onBarMetricChange,
  summaryData,
  summaryLoading,
  className = ''
}) => {
  return (
    <Card className={`shadow-sm ${className}`}>
      {/* Controls */}
      <div className="space-y-4 mb-6">
        {/* Two Column Layout: Left for Controls, Right for Summary */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Left Column: Campaign Selection and Metrics */}
          <div className="lg:col-span-2 space-y-4">
            {/* Campaign Selection */}
            <CampaignSelector
              selectedCampaignIds={selectedCampaignIds}
              selectedCampaignNames={selectedCampaignNames}
            />

            {/* Metrics Selection */}
            <MetricSelector
              value={selectedMetrics}
              onChange={onMetricChange}
              metrics={visibleMetrics}
              gridCols={2}
            />
          </div>

          {/* Right Column: Campaign Totals Summary */}
          <div className="lg:col-span-1">
            <CampaignTotalsSummary
              selectedCampaignIds={selectedCampaignIds}
              selectedMetrics={selectedMetrics}
              summaryData={summaryData}
              summaryLoading={summaryLoading}
            />
          </div>
        </div>

        {/* Time Controls */}
        <TimeControls
          timeGranularity={timeGranularity}
          onTimeGranularityChange={onTimeGranularityChange}
          dateRange={dateRange}
          onDateRangeChange={onDateRangeChange}
        />

        {/* Bar Metric Selector */}
        <BarMetricSelector
          value={barMetric}
          onChange={onBarMetricChange}
          selectedMetrics={selectedMetrics}
        />
      </div>
    </Card>
  )
}
